<template>
    <ais-instant-search
        :search-client="client"
        :index-name="index"
    >
        <algolia-results
            :facets="facets"
            :disjunctive-facets="disjunctiveFacets"
            :page="page"
            :per-page="perPage"
            @success="$emit('success', arguments[0])"
            @got="hasGot"
        >
            <slot
                slot-scope="{
                    data,
                    meta,
                    clear,
                    filterByQuery,
                    filterByLatlng,
                    filterByRadius,
                    filterByNumeric,
                    filterByBoolean,
                    filterByDisjunctiveFacet,
                    get
                }"
                :data="data"
                :meta="meta"
                :clear="clear"
                :filterByQuery="filterByQuery"
                :filterByLatlng="filterByLatlng"
                :filterByRadius="filterByRadius"
                :filterByNumeric="filterByNumeric"
                :filterByBoolean="filterByBoolean"
                :filterByDisjunctiveFacet="filterByDisjunctiveFacet"
                :get="get"
            />
        </algolia-results>
    </ais-instant-search>
</template>

<script>
    import _ from 'lodash'
    import algoliasearch from 'algoliasearch/lite'
    import AlgoliaResults from './algolia-results'

    const algolia = algoliasearch(
        _.preload('keys.algolia.app-id'),
        _.preload('keys.algolia.key')
    )

    const hasSearched = {}

    export default {
        components: {
            AlgoliaResults
        },
        props: {
            uuid: {
                type: String,
                default: () => _.uuid()
            },
            index: {
                type: String,
                required: true
            },
            facets: {
                type: Array,
                default: () => []
            },
            disjunctiveFacets: {
                type: Array,
                default: () => []
            },
            page: {
                type: Number,
                default: 1
            },
            perPage: {
                type: Number,
                default: 25
            },
            preloaded: {
                type: [Object, null],
                default: null
            },
            getOnCreated: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            client () {
                return {
                    search: (requests) => {
                        if (!this.getOnCreated && !hasSearched[this.uuid]) {
                            return Promise.resolve({
                                results: requests.map(() => ({
                                    hits: _.get(this.preloaded, 'data', []),
                                    nbHits: _.get(this.preloaded, 'meta.total', 0),
                                    hitsPerPage: _.get(this.preloaded, 'meta.per_page', 0),
                                    page: _.get(this.preloaded, 'meta.page', 0),
                                    nbPages: _.get(this.preloaded, 'meta.last_page', 0),
                                    processingTimeMS: 0
                                }))
                            })
                        }

                        return algolia.search(requests)
                    }
                }
            }
        },
        methods: {
            hasGot () {
                hasSearched[this.uuid] = true
            }
        }
    }
</script>
